module.exports = __webpack_public_path__ + "img/logo-freshsolution@2x.958efe68.png";